import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import NumberBaseConverter from '../../components/NumberBaseConverter';

const NumberBaseConvert: React.FC = () => (
  <ToolLayout
    title="Number Base Converter - Binary, Hex, Decimal, Octal | AllTools"
    description="Convert numbers between binary, hexadecimal, decimal, and octal bases. Free number base converter."
    canonicalPath="/number-base-converter"
  >
    <NumberBaseConverter />
  </ToolLayout>
);

export default NumberBaseConvert;
